package br.com.texeratx.boardgametimeapp.core.theme

enum class AppThemeMode(val storageValue: String) {
    DEFAULT("default"),
    SHADOW("shadow");

    companion object {
        fun fromStorage(value: String?): AppThemeMode? =
            entries.firstOrNull { it.storageValue == value }
    }
}
